module.exports = __webpack_public_path__ + "static/media/Adobe_Illustrator.d29d36c5.svg";